// src/components/notes/NoteList.jsx
import React from 'react';
import '../../styles/CommentSidebar.css';

export default function NoteList({ notes, onDelete }) {
  return (
    <div className="comment-list">
      {notes.length === 0 ? (
        <p className="empty-comment">No notes yet.</p>
      ) : (
        notes.map(note => (
          <div key={note.id} className="comment-card" style={{ position: 'relative' }}>
            {note.quote && <blockquote className="comment-quote">{note.quote}</blockquote>}
            <p className="comment-text">{note.text}</p>
            <div style={{ fontSize: 12, color: '#7a7a7a' }}>
              {typeof note.page === 'number' ? <>Page {note.page}</> : 'Free-form note'}
            </div>
            <button
              type="button"
              onClick={() => onDelete?.(note)}
              style={{
                position: 'absolute', right: 8, top: 8,
                border: 'none', background: 'transparent', cursor: 'pointer', color: '#a00'
              }}
              aria-label="Delete note"
              title="Delete note"
            >
              ✕
            </button>
          </div>
        ))
      )}
    </div>
  );
}
